import { render } from "./HelpCircle.vue?vue&type=template&id=389ba126"
import script from "./HelpCircle.vue?vue&type=script&lang=js"
export * from "./HelpCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/HelpCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "389ba126"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('389ba126', __exports__)) {
    api.reload('389ba126', __exports__)
  }
  
  module.hot.accept("./HelpCircle.vue?vue&type=template&id=389ba126", () => {
    api.rerender('389ba126', render)
  })

}


export default __exports__